module.exports = __webpack_public_path__ + "media/images/common/check-061a340c3a50a2ab994e50a0a0b39318.svg";